import React from 'react';
import { issaBadgeSquare, trustPhotoUrl } from '../../data/mock';

export default function Trust() {
  return (
    <section className="py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-5 gap-10 items-center">
        <div className="lg:col-span-2 relative">
          <div className="aspect-[4/5] rounded-[2rem] overflow-hidden shadow-xl border border-splash-sand">
            <img
              src={trustPhotoUrl}
              alt="Coach and toddler with fish toys in a calm indoor pool"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-4 shadow-xl border border-splash-sand w-[180px] h-[180px] grid place-items-center">
            <img src={issaBadgeSquare} alt="ISSA Accredited Swim School" loading="lazy" decoding="async" className="w-full h-full object-contain" />
          </div>
        </div>
        <div className="lg:col-span-3">
          <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Built On Trust</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-splash-green leading-tight">A calm place where confidence starts.</h2>
          <p className="mt-6 text-splash-green/80 text-lg leading-relaxed">
            We empower young swimmers to find their confidence in the water through personalized teaching and safety techniques that put parents at ease. Our mission is to transform every little splash into a foundation of lifelong bravery and trust in the water.
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {[
              ['Private heated indoor pool', 'Comfortable water year-round'],
              ['One class at a time', 'Distraction-free environment'],
              ['Small class sizes', 'Max 4 swimmers per class'],
              ['ISSA Accredited', 'WSI, CPR/AED, First Aid certified'],
            ].map(([t, s]) => (
              <div key={t} className="rounded-2xl bg-splash-cream border border-splash-sand p-4">
                <div className="font-semibold text-splash-green">{t}</div>
                <div className="text-sm text-splash-green/70 mt-1">{s}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
